import { find, includes } from 'lodash';

const PBG_DEFAULT = 'https://res.cloudinary.com/hjacivvox/image/upload/img_generic_ztfdsc.png';

export const ORIGINAL = 'original';
export const BACKGROUND = 'background';
export const SMALL_FOUR_THIRD = 'small_square';
export const MEDIUM_FOUR_THIRD = 'medium_four_third';
export const LARGE_FOUR_THIRD = 'large_four_third';
export const FULL_FOUR_THIRD = 'full_four_third';
export const SMALL_LANDSCAPE = 'small_landscape';
export const FULL_FOUR_THIRD_MOBILE = 'full_four_third_mobile';

export const extractImage = (images = [], version, defaultImageUrl) => {
  const image = find(images, findByVersion(version));
  return image || { url: applyTransformations(defaultImageUrl || PBG_DEFAULT, version) };
};

export const hasImageVersion = (images = [], version) => {
  return includes(images, findByVersion(version));
};

const findByVersion = (version) => (img) => img.version === version;

// We don't want this cloudinary logic to polute everything.
// These functions and transformations are to be used here exclusively.
// Do not export them ir copy them somewhere else unless we all agree is ok to do so.
const applyTransformations = (imageUrl, version) => {
  const transformations = buildTransformationString(version);
  return imageUrl.replace('/image/upload/', `/image/upload/${transformations}/`);
};

const buildTransformationString = (version) => {
  switch (version) {
    case BACKGROUND:
      return 'e_blur:300,q_auto/';
    case SMALL_FOUR_THIRD:
      return 'c_fill,w_180,h_137/';
    case MEDIUM_FOUR_THIRD:
      return 'c_fill,w_220,h_168/';
    case LARGE_FOUR_THIRD:
      return 'c_fill,w_260,h_198/';
    case FULL_FOUR_THIRD:
      return 'h_446,w_585,c_limit,c_pad,g_center,b_black';
    case FULL_FOUR_THIRD_MOBILE:
      return 'c_fill,h_446,w_585/'
    case SMALL_LANDSCAPE:
      return 'c_fill,w_200,h_100/';
    default:
      return '';
  }
};



// WEBPACK FOOTER //
// ./src/lib/image-versions.js